import { styled } from 'linaria/react';
import React, { memo } from 'react';
const LabelStyles = /*#__PURE__*/styled("div")({
  name: "LabelStyles",
  class: "l195y29z"
});
const UrgentJobLabel = () => {
  return <LabelStyles />;
};
export default memo(UrgentJobLabel);

require("../../../.linaria-cache/src/components/UrgentJob/UrgentJobLabel.linaria.module.css");